export enum SubscriptionBillingTimeEnum {
  FIRST_DAY_BILLING_PERIOD = 'first_day_of_billing_period',
  LAST_DAY_BILLING_PERIOD = 'last_day_of_billing_period',
  SUBSCRIPTION_START_DATE = 'subscription_start_date',
}
